import { useState, useEffect } from 'react';

export const TypeAnimation = ({ text, speed = 100, loop = false }: { text: string; speed?: number; loop?: boolean }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + (text[index] ?? ''));
        setIndex((prev) => prev + 1);
      }, speed);
      return () => {
        clearTimeout(timeout);
      };
    } else if (loop) {
      const timeout = setTimeout(() => {
        setDisplayedText('');
        setIndex(0);
      }, 1000);
      return () => {
        clearTimeout(timeout);
      };
    }
    return undefined;
  }, [index, text, speed, loop]);
  return <p className="type-animation">{displayedText}</p>;
};
